<template>
  <v-app>
    <component :is="layout" />
    <!-- <core-filter />

    <core-toolbar />

    <core-drawer />

    <core-view /> -->
  </v-app>
</template>

<script>
  const defaultLayout = 'public'
  export default {
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    }
  }
</script>

<style>
html {
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
html::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
}
</style>
<!--style lang="scss">
  // @import '@/styles/index.scss';
</style-->
